export const SHOW_BID_DETAILS = 'SHOW_BID_DETAILS';
